import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function WatermelonSorbet() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Watermelon Sorbet</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>A refreshing frozen treat made with fresh watermelon, perfect for hot summer days.</p>
          <span className="season-badge season-summer">☀️ Best in Summer</span>
          <ImageWithFallback src="/watermelon_sorbet.jpg" alt="Watermelon Sorbet" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 16 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>4 cups fresh watermelon, cubed and seeded</li>
              <li>2 tbsp fresh lime juice</li>
              <li>1 tbsp honey (optional)</li>
              <li>Pinch of salt</li>
              <li>Fresh mint leaves for garnish</li>
            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Cut a watermelon into cubes and remove the seeds.</li>
              <li>Throw the cubes into a shallow, freezer-safe dish and freeze for 4 hours.</li>
              <li>Once frozen, blend the rock hard watermelon cubes until smooth.</li>
              <li>Serve scooped into bowls and garnish with fresh mint leaves. Enjoy this refreshing summer treat!</li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Freeze the watermelon in a single layer so the cubes don't clump into one solid block.</li>
              <li>Let the frozen cubes sit for a minute or two before blending so your blender doesn't strain.</li>
              <li>A splash of lime juice keeps the sorbet from tasting flat once frozen.</li>
              <li>Re-freeze the blended sorbet for 30 minutes for a firmer, scoopable texture.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Watermelon is over 90% water, making this sorbet a hydrating way to cool off.</li>
              <li>Rich in lycopene and vitamin C, both linked to heart and skin health.</li>
              <li>Naturally fat-free and much lower in sugar than most store-bought frozen desserts.</li>
              <li>A satisfying way to end a meal without the heaviness of cream-based ice cream.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default WatermelonSorbet;
